module.exports = __webpack_public_path__ + "img/event1.146e557a.png";